import { render, staticRenderFns } from "./AgreementRenderer.vue?vue&type=template&id=126ee348&scoped=true&"
import script from "./AgreementRenderer.vue?vue&type=script&lang=js&"
export * from "./AgreementRenderer.vue?vue&type=script&lang=js&"
import style0 from "./AgreementRenderer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AgreementRenderer.vue?vue&type=style&index=1&id=126ee348&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ee348",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VThemeProvider})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126ee348')) {
      api.createRecord('126ee348', component.options)
    } else {
      api.reload('126ee348', component.options)
    }
    module.hot.accept("./AgreementRenderer.vue?vue&type=template&id=126ee348&scoped=true&", function () {
      api.rerender('126ee348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/AgreementRenderer.vue"
export default component.exports